import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AppService, AppSettingService } from '../../app.service';
import { FileManagementApiService } from '../../fileManagement/file-management-api.service';
import { FileManagementService } from '../../fileManagement/file-management.service';

@Component({
	selector: 'app-action-more-delete-folder',
	templateUrl: "./action-more-delete-folder.component.html",
	standalone: false
})
export class ActionMoreDeleteFolderComponent implements OnInit {
	@Input() folderData: any;
	//this needs to be an rxjs event because there is now way to communicate from the card to the carousel: @Output() doneDeleting: EventEmitter<any> = new EventEmitter();
	constructor(
		private router: Router,
		private fileManagementApiService: FileManagementApiService,
		private fileManagementService: FileManagementService
	) { }

	onSelected() {		
		this.fileManagementService.confirmDeleteFolder(this.folderData.FolderName).then(
			(response) => {
				if (response.isConfirmed) {
					this.fileManagementApiService.deleteFolder(this.folderData.FolderId).subscribe(
						(response) => {							
							this.fileManagementService.emitFolderDeletedEvent(this.folderData);
						},
						(error) => {
							console.log(error);
						}
					);
				}
			}
		);
	}

	ngOnInit(): void {		
	}
}
